import { render, staticRenderFns } from "./ActivityLogsPanel.vue?vue&type=template&id=0bb8dfb6&scoped=true"
import script from "./ActivityLogsPanel.vue?vue&type=script&lang=js"
export * from "./ActivityLogsPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogsPanel.vue?vue&type=style&index=0&id=0bb8dfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8dfb6",
  null
  
)

export default component.exports